import { tsv } from "@faire/slate/lib/tsv";
import * as React from "react";

type IProps = React.HTMLAttributes<HTMLDivElement>;

export const SkeletonBase: React.FC<IProps> = ({ className, ...props }) => (
  <div {...props} className={skeletonStyles.cls({ className })} />
);

const skeletonStyles = tsv({
  vars: {
    width: "fs-skeleton-width",
    height: "fs-skeleton-height",
    radius: "fs-skeleton-border-radius",
  },
  base: "fs-skeleton",
});

export const skeletonVars = skeletonStyles.vars;
